import React from "react";
import { constants } from "@thecb/components";

const MaintenanceIcon = () => {
  const color = constants.colors.LUCKY_POINT;
  return (
    <svg
      width="475"
      height="308"
      viewBox="0 0 475 308"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M420.296 247.376L356.54 247.724"
        stroke="#292A33"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        d="M469.924 247.376L440.089 247.724"
        stroke="#292A33"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        d="M100.095 247.376L47.7229 247.724"
        stroke="#292A33"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        d="M28.1628 247.376L12.9838 247.724"
        stroke="#292A33"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.468 73H348.189C352.038 73 355.158 76.12 355.158 79.968V258.366C355.158 262.214 352.038 265.334 348.189 265.334H108.468C104.619 265.334 101.5 262.214 101.5 258.366V79.968C101.5 76.12 104.619 73 108.468 73Z"
        fill="white"
      />
      <path
        d="M198.311 147.488C199.479 144.23 202.471 141.913 205.977 141.913C209.482 141.913 212.474 144.23 213.642 147.488"
        stroke="#292A33"
        strokeWidth="5.575"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M244.311 147.488C245.479 144.23 248.471 141.913 251.977 141.913C255.482 141.913 258.474 144.23 259.642 147.488"
        stroke="#292A33"
        strokeWidth="5.575"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M248.691 192.886V192.886C248.691 189.083 245.608 186 241.805 186H215.385C211.583 186 208.5 189.083 208.5 192.886"
        stroke="#292A33"
        strokeWidth="5.575"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.5 99H355.5V73H101.5V99Z"
        fill="#CACED8"
      />
      <circle cx="114.5" cy="86" r="3" fill="#292A33" />
      <circle cx="124.5" cy="86" r="3" fill="#292A33" />
      <circle cx="134.5" cy="86" r="3" fill="#292A33" />
      <path d="M104.5 99H352.5" stroke="#292A33" strokeWidth="6" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M286.827 294.916C286.827 302.049 260.786 307.832 228.663 307.832C196.54 307.832 170.5 302.049 170.5 294.916C170.5 287.783 196.54 282 228.663 282C260.786 282 286.827 287.783 286.827 294.916Z"
        fill={color}
        fillOpacity="0.2"
      />
      <path
        d="M220.317 268V292.795H204.5"
        stroke={color}
        strokeWidth="8.362"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M235.81 268V293.574H251.627"
        stroke={color}
        strokeWidth="8.362"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M99.9409 205.181L77.6809 224.512"
        stroke={color}
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M413.396 190.765L381.627 224.79L356.5 205.268"
        stroke={color}
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M397 189.5H430"
        stroke={color}
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.469 73H348.19C352.038 73 355.158 76.12 355.158 79.969V258.366C355.158 262.214 352.038 265.334 348.19 265.334H108.469C104.62 265.334 101.5 262.214 101.5 258.366V79.969C101.5 76.12 104.62 73 108.469 73Z"
        stroke="#292A33"
        strokeWidth="6"
      />
      <path
        d="M77.6812 224.512L128.405 236.375"
        stroke={color}
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M137.579 231.103C133.379 231.103 129.974 234.508 129.974 238.708C129.974 242.909 133.379 246.314 137.579 246.314H144.223"
        stroke={color}
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M453.18 155.302C451.163 157.996 448.759 160.384 446.051 162.382C445.075 163.102 443.715 162.995 442.858 162.138L439.938 159.218C439.136 158.416 437.923 158.218 436.897 158.698C436.431 158.916 435.958 159.12 435.479 159.312C435.178 159.431 434.875 159.545 434.571 159.655C433.487 160.039 432.745 161.041 432.745 162.192L432.744 166.276C432.744 167.493 431.854 168.533 430.65 168.706C429.04 168.939 427.395 169.059 425.721 169.059C424.013 169.059 422.335 168.934 420.695 168.693C419.492 168.516 418.604 167.478 418.604 166.262V162.151C418.604 161.024 417.895 160.02 416.833 159.641C415.969 159.331 415.125 158.979 414.305 158.584C413.282 158.093 412.064 158.298 411.261 159.1L408.377 161.985C407.515 162.847 406.146 162.949 405.17 162.218C402.504 160.218 400.14 157.839 398.156 155.16C397.434 154.185 397.539 152.823 398.397 151.966L401.311 149.05C402.109 148.251 402.314 147.041 401.832 146.021C401.473 145.257 401.149 144.474 400.862 143.672C400.481 142.609 399.479 141.896 398.349 141.897H394.239C393.023 141.897 391.985 141.008 391.808 139.806C391.567 138.165 391.442 136.487 391.442 134.78C391.442 133.072 391.567 131.394 391.808 129.753C391.985 128.551 393.023 127.662 394.238 127.662H398.349C399.479 127.662 400.482 126.949 400.863 125.885C401.142 125.103 401.458 124.337 401.808 123.59C402.286 122.569 402.081 121.361 401.284 120.564L398.362 117.643C397.504 116.785 397.398 115.426 398.117 114.45C400.117 111.741 402.504 109.337 405.198 107.32C406.173 106.59 407.542 106.693 408.404 107.554L411.292 110.444C412.094 111.245 413.311 111.45 414.333 110.961C415.145 110.572 415.979 110.224 416.833 109.918C417.896 109.539 418.604 108.535 418.604 107.407V103.297C418.604 102.082 419.492 101.043 420.695 100.866C422.335 100.625 424.013 100.5 425.721 100.5C427.42 100.5 429.09 100.624 430.723 100.863C431.936 101.04 432.827 102.095 432.814 103.322L432.767 107.351C432.754 108.494 433.47 109.514 434.547 109.897C435.389 110.195 436.21 110.535 437.01 110.914C438.038 111.401 439.26 111.189 440.058 110.377L442.906 107.481C443.762 106.61 445.134 106.497 446.116 107.225C448.788 109.206 451.162 111.568 453.159 114.229C453.891 115.204 453.788 116.573 452.926 117.435L450.041 120.32C449.24 121.122 449.034 122.34 449.526 123.364C449.92 124.184 450.273 125.028 450.582 125.893C450.962 126.954 451.965 127.662 453.093 127.662H457.203C458.418 127.662 459.457 128.551 459.634 129.753C459.875 131.394 460 133.072 460 134.78C460 136.49 459.874 138.171 459.633 139.815C459.456 141.013 458.424 141.9 457.213 141.906L453.072 141.923C451.949 141.928 450.952 142.635 450.573 143.692C450.27 144.537 449.925 145.363 449.54 146.165C449.05 147.189 449.254 148.406 450.057 149.208L452.947 152.096C453.808 152.958 453.91 154.326 453.18 155.302Z"
        fill="#CACED8"
        stroke="#292A33"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M382.655 168.156C381.405 169.826 379.914 171.306 378.234 172.546C377.63 172.992 376.787 172.927 376.255 172.395L374.444 170.584C373.947 170.087 373.195 169.964 372.558 170.261C372.27 170.396 371.976 170.523 371.678 170.642C371.493 170.717 371.305 170.787 371.116 170.854C370.444 171.094 369.984 171.715 369.984 172.427V174.961C369.984 175.715 369.431 176.36 368.684 176.468C367.686 176.611 366.666 176.685 365.629 176.685C364.57 176.685 363.529 176.608 362.511 176.459C361.766 176.349 361.216 175.706 361.216 174.952L361.215 172.402C361.215 171.704 360.776 171.081 360.118 170.846C359.582 170.654 359.058 170.435 358.55 170.191C357.915 169.886 357.16 170.013 356.662 170.51L354.874 172.3C354.34 172.834 353.49 172.898 352.885 172.444C351.232 171.204 349.766 169.728 348.536 168.068C348.088 167.463 348.153 166.619 348.685 166.087L350.492 164.279C350.987 163.784 351.114 163.034 350.816 162.4C350.592 161.927 350.391 161.441 350.214 160.944C349.977 160.285 349.356 159.843 348.655 159.843H346.106C345.353 159.843 344.709 159.293 344.599 158.547C344.45 157.529 344.373 156.489 344.373 155.43C344.373 154.371 344.45 153.331 344.599 152.313C344.709 151.568 345.353 151.017 346.106 151.017H348.655C349.356 151.017 349.978 150.575 350.214 149.915C350.387 149.429 350.584 148.955 350.801 148.492C351.097 147.858 350.969 147.109 350.475 146.615L348.664 144.803C348.132 144.272 348.066 143.429 348.512 142.824C349.752 141.144 351.232 139.654 352.902 138.403C353.508 137.95 354.356 138.013 354.89 138.549L356.681 140.34C357.178 140.837 357.933 140.964 358.567 140.66C359.07 140.42 359.588 140.204 360.117 140.014C360.776 139.779 361.216 139.156 361.216 138.457V135.908C361.216 135.155 361.766 134.51 362.511 134.401C363.529 134.252 364.57 134.175 365.629 134.175C366.682 134.175 367.717 134.251 368.73 134.399C369.482 134.509 370.035 135.164 370.026 135.924L369.998 138.423C369.989 139.131 370.433 139.763 371.101 140.001C371.623 140.185 372.133 140.396 372.629 140.632C373.266 140.933 374.023 140.802 374.518 140.299L376.285 138.503C376.815 137.963 377.667 137.892 378.275 138.344C379.932 139.573 381.404 141.037 382.642 142.687C383.096 143.292 383.033 144.14 382.498 144.676L380.709 146.464C380.212 146.962 380.085 147.717 380.389 148.351C380.634 148.86 380.852 149.384 381.045 149.92C381.28 150.578 381.902 151.017 382.601 151.017L385.15 151.016C385.904 151.016 386.548 151.568 386.657 152.313C386.806 153.331 386.884 154.371 386.884 155.43C386.884 156.491 386.806 157.533 386.656 158.552C386.547 159.295 385.907 159.845 385.156 159.848L382.588 159.86C381.891 159.863 381.274 160.302 381.039 160.957C380.85 161.48 380.636 161.992 380.398 162.49C380.094 163.125 380.221 163.88 380.718 164.377L382.51 166.168C383.045 166.702 383.108 167.551 382.655 168.156Z"
        fill="#CACED8"
        stroke="#292A33"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M415.5 134.779C415.5 140.424 420.076 145 425.721 145C431.365 145 435.941 140.424 435.941 134.779C435.941 129.134 431.365 124.558 425.721 124.558C420.076 124.558 415.5 129.134 415.5 134.779Z"
        fill="#F6F6F9"
        stroke="#292A33"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M359.29 155.431C359.29 158.931 362.127 161.768 365.628 161.768C369.128 161.768 371.966 158.931 371.966 155.431C371.966 151.93 369.128 149.093 365.628 149.093C362.127 149.093 359.29 151.93 359.29 155.431Z"
        fill="#F6F6F9"
        stroke="#292A33"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M422.029 40.973C419.723 40.973 417.595 41.716 415.854 42.963C415.022 34.01 407.492 27 398.322 27C390.25 27 383.452 32.432 381.37 39.838C379.295 38.285 376.726 37.354 373.935 37.354C367.067 37.354 361.5 42.921 361.5 49.789C361.5 56.657 367.067 62.223 373.935 62.223H422.029C427.897 62.223 432.654 57.467 432.654 51.598C432.654 45.73 427.897 40.973 422.029 40.973Z"
        fill={color}
        fillOpacity="0.2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M167.018 25.524C164.266 25.524 161.726 26.41 159.646 27.899C158.654 17.212 149.665 8.84497 138.719 8.84497C129.083 8.84497 120.969 15.329 118.484 24.17C116.006 22.316 112.941 21.204 109.608 21.204C101.411 21.204 94.7649 27.85 94.7649 36.047C94.7649 44.245 101.411 50.891 109.608 50.891H167.018C174.022 50.891 179.701 45.212 179.701 38.208C179.701 31.203 174.022 25.524 167.018 25.524Z"
        fill={color}
        fillOpacity="0.2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69.991 141.356C68.741 141.356 67.556 141.631 66.485 142.113C65.429 140.771 63.793 139.906 61.953 139.906C61.412 139.906 60.891 139.985 60.394 140.125C58.447 135.058 53.548 131.456 47.796 131.456C41.527 131.456 36.27 135.733 34.747 141.525C34.201 141.415 33.636 141.356 33.057 141.356C28.331 141.356 24.5 145.187 24.5 149.913C24.5 154.639 28.331 158.47 33.057 158.47H69.991C74.717 158.47 78.548 154.639 78.548 149.913C78.548 145.187 74.717 141.356 69.991 141.356Z"
        fill={color}
        fillOpacity="0.2"
      />
    </svg>
  );
};

export default MaintenanceIcon;
